import style from "./SamplePage.module.scss";

const SamplePage = () => {
  return (
    <div className={style.samplePage}>
      <div className="container">
        <h1>Lorem Ipsum</h1>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio
          dignissimos consectetur libero quos nostrum, beatae harum laudantium
          modi, magnam inventore ipsum provident eos accusantium officiis iste
          suscipit ut illo eius nemo reiciendis molestias, minus magni alias?
          Asperiores eligendi amet delectus explicabo ipsum sint natus.
          Aspernatur eos perspiciatis nihil sit reprehenderit.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo at
          facilis rem voluptatum accusantium voluptate, eum quia earum repellat,
          reprehenderit illo inventore sint optio, dolor eius nihil dolore? Qui
          quidem ad sint, saepe quasi culpa? Quod cum iusto tenetur dolore,
          harum accusamus libero reprehenderit sapiente in atque! Ad veritatis,
          quidem doloremque non alias odio, ullam nemo animi fugiat assumenda
          quia.
        </p>

        <h2>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor,
          assumenda.
        </h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis
          perspiciatis veniam doloribus alias molestiae totam quas ab
          praesentium, neque perferendis, soluta officiis illo provident dolores
          dolorum nobis beatae cumque <button type="button" className="link-style">quisquam</button> ratione nihil
          sunt, aperiam ducimus. Tenetur, quo. Architecto voluptatem libero nemo
          at nisi cupiditate ducimus! Iusto quia at nihil quidem dolores! A
          minus consectetur quibusdam assumenda aperiam, similique sapiente
          commodi modi fuga, dolor pariatur nam harum, delectus debitis?
          Laudantium doloribus aperiam, dicta vel tempore iure dolor excepturi
          sit? Ducimus, ipsam.
        </p>

        <h3>Lorem ipsum dolor sit amet.</h3>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquid,
          error?
        </p>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est dolorum,
          dolores, ipsam explicabo excepturi temporibus ut ipsum quaerat nobis
          distinctio nesciunt exercitationem dolore illo quos necessitatibus.
          Quibusdam, necessitatibus voluptatum! Architecto ullam, dolor vitae
          sed eos dolorem error. Quos dolor, velit quisquam veniam dolorum earum
          a dicta rem libero id, perspiciatis obcaecati odio dolore omnis quae
          totam iusto maxime autem officiis quam? Velit repudiandae fugiat enim
          magni vel eaque, in mollitia.
        </p>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est dolorum,
          dolores, ipsam explicabo excepturi temporibus ut ipsum quaerat nobis
          distinctio nesciunt exercitationem dolore illo quos necessitatibus.
          Quibusdam, necessitatibus voluptatum! Architecto ullam, dolor vitae
          sed eos dolorem error. Quos dolor, velit quisquam veniam dolorum earum
          a dicta rem libero id, perspiciatis obcaecati odio dolore omnis quae
          totam iusto maxime autem officiis quam? Velit repudiandae fugiat enim
          magni vel eaque, in mollitia.
        </p>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est dolorum,
          dolores, ipsam explicabo excepturi temporibus ut ipsum quaerat nobis
          distinctio nesciunt exercitationem dolore illo quos necessitatibus.
          Quibusdam, necessitatibus voluptatum! Architecto ullam, dolor vitae
          sed eos dolorem error. Quos dolor, velit quisquam veniam dolorum earum
          a dicta rem libero id, perspiciatis obcaecati odio dolore omnis quae
          totam iusto maxime autem officiis quam? Velit repudiandae fugiat enim
          magni vel eaque, in mollitia.
        </p>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est dolorum,
          dolores, ipsam explicabo excepturi temporibus ut ipsum quaerat nobis
          distinctio nesciunt exercitationem dolore illo quos necessitatibus.
          Quibusdam, necessitatibus voluptatum! Architecto ullam, dolor vitae
          sed eos dolorem error. Quos dolor, velit quisquam veniam dolorum earum
          a dicta rem libero id, perspiciatis obcaecati odio dolore omnis quae
          totam iusto maxime autem officiis quam? Velit repudiandae fugiat enim
          magni vel eaque, in mollitia.
        </p>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est dolorum,
          dolores, ipsam explicabo excepturi temporibus ut ipsum quaerat nobis
          distinctio nesciunt exercitationem dolore illo quos necessitatibus.
          Quibusdam, necessitatibus voluptatum! Architecto ullam, dolor vitae
          sed eos dolorem error. Quos dolor, velit quisquam veniam dolorum earum
          a dicta rem libero id, perspiciatis obcaecati odio dolore omnis quae
          totam iusto maxime autem officiis quam? Velit repudiandae fugiat enim
          magni vel eaque, in mollitia.
        </p>
      </div>
    </div>
  );
};
export default SamplePage;
